<!-- 申请记录详情 -->
<template>
  <div class="backgroundGrey base-padding">
    <div class="details-card">
      <div class="details-title">
        航班信息
      </div>
      <div class="detailsItem">
        <div>
          <span>航班日期：</span>
          <span>{{ main.flightDate }}</span>
        </div>
        <div>
          <span>航线环：</span>
          <span>{{ main.flightNoRing }}</span>
        </div>
        <div>
          <span>航段环：</span>
          <span>{{ main.flightLineRing }}</span>
        </div>
      </div>
    </div>
    <div class="details-card">
      <div class="details-title">
        商品信息
      </div>
      <Grid :columns="columns" :tableData="main.details" />
    </div>
    <div class="details-card">
      <div class="details-title">
        基本信息
      </div>
      <div class="detailsItem">
        <div>
          <span>申请单号：</span>
          <span>{{ main.applyNo }}</span>
        </div>
        <div>
          <span>申请人：</span>
          <span>{{ main.applyStaffName }}</span>
        </div>
        <div>
          <span>申请时间：</span>
          <span>{{ main.createdTime }}</span>
        </div>
        <div>
          <span>状态：</span>
          <span>{{ $utils.subAppStatus(main.applyStatus) }}</span>
        </div>
        <div v-if="main.applyStatus === 4">
          <span>原因：</span>
          <span>{{ main.rejectMsg }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Grid from '@/components/common/Grid/index.vue'

export default {
  components: {
    Grid,
  },
  data() {
    return {
      main: {},
    }
  },
  activated() {
    this.main = this.$route.query
    this.getDetailBySupplier()
  },
  computed: {
    columns() {
      let arr = [
        { label: '商品名称', prop: 'productName' },
        { label: '规格', prop: 'sku' },
        { label: '售价', prop: 'price' },
        { label: '配货数量', prop: 'quantity' },
      ]
      if (this.main.applyStatus === 5) {
        arr.push({ label: '可供数量', prop: 'realQuantity' })
      }
      return arr
    },
  },
  methods: {
    // 获取详情
    getDetailBySupplier() {
      let url = `/api-sys/sell/addMatterSearch/getDetailBySupplier?supplierId=${this.$store.state.userInfo.vonderId}&applyId=${this.main.id}`
      this.$api.get(url).then((res) => {
        this.main = res.data
      })
    },
  },
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/view/ApplicationRecord/ApplicationRecordSupplyDetails.vue